export default function toSentence(itemsArr, useOxfordComma = true) {
  let sentenceStart = '';
  let sentenceEnd = '';
  if (itemsArr.length > 1) {
    sentenceStart = itemsArr.slice(0, -1).join(', ');
    if (useOxfordComma && itemsArr.length > 2) {
      sentenceStart += ',';
    }
    sentenceEnd = ` and ${itemsArr[itemsArr.length - 1]}`;
  } else {
    sentenceStart = itemsArr[0];
  }
  return `${sentenceStart}${sentenceEnd}`;
}
